import React from 'react';
import * as R from 'react-router-dom';

import {
    Drawer, List, ListItem, ListItemIcon, ListItemText,
} from '@material-ui/core';
import * as I from '@material-ui/icons';

import {url_for} from 'aauth/components/Router';

export default function NavDrawer({open, onClose}) {
    return (
        <Drawer open={open} onClose={onClose}>
            <List>
                <ListItem button component={R.Link} to={url_for('home')}>
                    <ListItemIcon><I.Home /></ListItemIcon>
                    <ListItemText primary="Home"/>
                </ListItem>
                <ListItem button component={R.Link} to={url_for('authorized')}>
                    <ListItemIcon><I.SupervisorAccount /></ListItemIcon>
                    <ListItemText primary="Authorized"/>
                </ListItem>
            </List>
        </Drawer>
    )
}
